module.exports = __webpack_public_path__ + "static/media/instagram.1a25ed80.png";